<template>
	<nav>
		<div class="bar">
			<RouterLink to="/" class="brand" @click="close">
				<img :src="clubLogo" alt="Karate klub Bregana" class="brand-logo" />
			</RouterLink>

			<div class="right">
				<div class="links" :class="{ open }">
					<RouterLink to="/" @click="close">Home</RouterLink>
					<RouterLink to="/about" @click="close">O nama</RouterLink>
					<RouterLink to="/schedule" @click="close">Raspored</RouterLink>
					<RouterLink to="/gallery" @click="close">Galerija</RouterLink>
					<RouterLink to="/results" @click="close">Rezultati</RouterLink>
					<RouterLink to="/contact" @click="close">Kontakt</RouterLink>
				</div>

				<ThemeSwitcher />

				<button
					type="button"
					class="toggle"
					:class="{ open }"
					:aria-expanded="open"
					aria-label="Izbornik"
					@click="open = !open"
				>
					<span></span>
					<span></span>
					<span></span>
				</button>
			</div>
		</div>
	</nav>
</template>

<script setup>
import { ref } from 'vue'
import { RouterLink } from 'vue-router'
import ThemeSwitcher from './ui/ThemeSwitcher.vue'
import clubLogo from '../assets/images/club-logo.png'

const open = ref(false)

function close() {
	open.value = false
}
</script>

<style lang="scss" scoped>
nav {
	position: relative;
	border-bottom: 1px solid var(--color-border);
}

.bar {
	max-width: var(--container-width);
	margin: 0 auto;
	padding: 1rem 1.5rem;
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.brand {
	display: flex;
	align-items: center;
}

.brand-logo {
	width: 40px;
	height: 40px;
	border-radius: 50%;
}

.right {
	display: flex;
	align-items: center;
	gap: 1.5rem;
}

.toggle {
	display: none;
	flex-direction: column;
	justify-content: center;
	gap: 5px;
	width: 32px;
	height: 32px;
	background: none;
	border: none;
	cursor: pointer;
	padding: 0;

	span {
		display: block;
		height: 2px;
		background: var(--color-text);
		border-radius: 2px;
		transition: transform 0.2s ease, opacity 0.2s ease;
	}

	&.open span:nth-child(1) {
		transform: translateY(7px) rotate(45deg);
	}
	&.open span:nth-child(2) {
		opacity: 0;
	}
	&.open span:nth-child(3) {
		transform: translateY(-7px) rotate(-45deg);
	}
}

.links {
	display: flex;
	gap: 2rem;
	align-items: center;

	a {
		text-decoration: none;
		color: var(--color-text-muted);
		font-family: var(--font-heading);
		font-weight: 600;
		font-size: 0.85rem;
		letter-spacing: 0.04em;
		text-transform: uppercase;
		white-space: nowrap;

		&:hover {
			color: var(--color-text);
		}

		&.router-link-exact-active {
			color: var(--color-accent);
		}
	}
}

@media (max-width: 920px) {
	.toggle {
		display: flex;
	}

	.links {
		display: none;
		position: absolute;
		top: 100%;
		left: 0;
		right: 0;
		flex-direction: column;
		align-items: stretch;
		gap: 0;
		background: var(--color-bg);
		border-bottom: 1px solid var(--color-border);
		padding: 0.5rem 1.5rem 1rem;
		z-index: 10;

		&.open {
			display: flex;
		}

		a {
			padding: 0.85rem 0;
			border-bottom: 1px solid var(--color-border);

			&:last-child {
				border-bottom: none;
			}
		}
	}
}
</style>
